exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal_color-office {\n  border-color: #7FB8C8 !important;\n  background-color: #7FB8C8 !important;\n}\n", ""]);

// exports
